<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>
<script>
import {downoknotify, config} from "@/services/user";
import Fingerprint2 from "fingerprintjs2";
import moment from "moment";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import {getIp, getPointByKey} from "@/services/common";
import {getEquipment} from "@/utils/index";
import instance from "@/utils/request";

export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    editUrl(url, aParam) {
      aParam.forEach((item) => {
        const fromindex = url.indexOf(`${item}=`);
        if (fromindex !== -1) {
          // 通过url特殊符号，计算出=号后面的的字符数，用于生成replace正则
          const startIndex = url.indexOf("=", fromindex);
          const endIndex = url.indexOf("&", fromindex);
          const hashIndex = url.indexOf("#", fromindex);

          let reg;
          if (endIndex !== -1) {
            // 后面还有search参数的情况
            const num = endIndex - startIndex;
            reg = new RegExp(`${item}=.{${num}}`);
            url = url.replace(reg, "");
          } else if (hashIndex !== -1) {
            // 有hash参数的情况
            const num = hashIndex - startIndex - 1;
            reg = new RegExp(`&?${item}=.{${num}}`);
            url = url.replace(reg, "");
          } else {
            // search参数在最后或只有一个参数的情况
            reg = new RegExp(`&?${item}=.+`);
            url = url.replace(reg, "");
          }
        }
      });
      const noSearchParam = url.indexOf("=");
      if (noSearchParam === -1) {
        url = url.replace(/\?/, ""); // 如果已经没有参数，删除？号
      }
      // return "/#" + url;
      return url;
    },
    // 获取浏览器的唯一标识符
    createFingerprint(ip) {
      // 浏览器指纹
      Fingerprint2.get((components) => {
        // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
        if (ip) {
          components.push({
            key: "ip",
            value: ip, //通过接口获取的到ip
          });
        }
        const values = components.map(function (component, index) {
          if (index === 0) {
            return component.value.replace(/\bNetType\/\w+\b/, "");
          }
          return component.value;
        });
        const visitorId = Fingerprint2.x64hash128(values.join(""), 31); // 生成浏览器指纹
        // console.log(components, values, visitorId);
        console.log("唯一标识visitorId: ", visitorId);
        localStorage.setItem("visitorId", visitorId);
        const params = {
          imei: visitorId,
          uuid: visitorId,

          app_version: "1.0.0",
          version: "1.0.0",
          download_time: moment().format("YYYY-MM-DD HH:mm:ss.SSS"),
          type: 1,
        };
        downoknotify(params);
        //murmur就是浏览器指纹啦
        // this.visitorId = visitorId;
      });
    },
    init() {
      // console.log("this.$tools", this.$tools)
      window.getWebUserData = this.getWebUserData;
      window.navToOnlinePay = this.navToOnlinePay;
      this.$tools.androidMethod("getUserData", {}, "getWebUserData");

      // window.getWebUserData({
      //   "result": "ok",
      //   "id": "0.8459706990489422",
      //   "action": "getUserData",
      //   "msg": "",
      //   "data": {
      //     "imei": "fc1fd1835a2ba514",
      //     "user_id": "220231220000015343",
      //     "tel": "01234321412",
      //     "version": "1.0.0",
      //     "pkg_name": "com.qcloan.vay24",
      //     "host": "https://h5.vay24.xyz/api",
      //     "loginStaticKey": "1DB6A6CB32B3EEFC72203D89D52CD418"
      //   }
      // })
    },
    getWebUserData(data) {
      console.log("获取安卓参数", data.data)
      data.data.phone = data.data.tel;
      data.data.vayHubAuthUrl = data.data.vay_path;
      // data.data.host = "https://h5.vay24.xyz/api";
      instnance.defaults.baseURL = data.data.host;
      this.$store.commit("SET_USER_INFO", data.data);
    },
    initializeTheBurialPoint() {
      console.log("this.$burialPoint", this.$burialPoint);
      this.$buriedPoints.initializeTheBurialPoint();
    },
    pixelEmbedding() {
      // let that = this;
      let channel = localStorage.getItem("channel")
      let pointByKey = localStorage.getItem("pointByKey")
      if (channel && pointByKey) {
        pointByKey = JSON.parse(pointByKey);
        console.log("facebookpixel", channel);
        if (pointByKey.type == 1) {
          // facebook埋点
          !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
              n.callMethod
                  ? n.callMethod.apply(n, arguments)
                  : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
          })(
              window,
              document,
              "script",
              "https://connect.facebook.net/en_US/fbevents.js"
          );
          window.fbq("init", pointByKey.pixelId);
          window.fbq("track", "PageView");

        }
        if (pointByKey.type == 2) {
          var script = document.createElement("script");
          script.type = "text/javascript";
          script.src = "https://www.googletagmanager.com/gtag/js?id=" + pointByKey.pixelId;
          script.onload = function () {
            window.dataLayer = window.dataLayer || [];
            gtag("js", new Date());

            gtag("config", pointByKey.pixelId);
          };
          document.head.appendChild(script);

          /* eslint-disable */
          function gtag() {
            dataLayer.push(arguments);
          }

          /* eslint-enable */
          window.gtag = gtag;
        }
      }
    },
  },
  async created() {
    let that = this;
    getEquipment();

    navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia;

    if (navigator.getUserMedia) {
      console.log("支持");
    } else {
      console.log("不支持");
    }

    if (!localStorage.getItem("againLoad")) {
      localStorage.setItem("againLoad", "1");
      /* eslint-disable */
      window.location.href = window.location.href;
      /* eslint-enable */
    }
    // let that = this;
    // console.log(dateFormat("YYYY-mm-dd", new Date("2021-04-15 23:59:59")));
    !that.$store.state.user.userInfo &&
    that.$store.commit(
        "SET_USER_INFO",
        JSON.parse(localStorage.getItem("userInfo") || "{}")
    );

    if (process.env.VUE_APP_GENRE === "nested") {
      !that.$store.state.user.isNested &&
      that.$store.commit("SET_IS_NESTED", true);
      return;
    }

    FingerprintJS.load().then((fp) => {
      fp.get().then(() => {

        if (that.$route.query.channel && that.$route.query.vayHub) {
          localStorage.setItem("channel", that.$route.query.channel);
          localStorage.setItem("vayHub", that.$route.query.vayHub);
          console.log("this.$route.query.channel", that.$route.query.channel);
          window.history.replaceState(
              "",
              "",
              that.editUrl(that.$route.fullPath, ["channel", "vayHub"])
              // this.editUrl(this.$route.fullPath, ["channel","vayHub"])
          );
          return;
        }
        if (that.$route.query.channel) {
          localStorage.setItem("channel", that.$route.query.channel);
          console.log("this.$route.query.channel", that.$route.query.channel);
          window.history.replaceState(
              "",
              "",
              that.editUrl(that.$route.fullPath, ["channel"])
              // this.editUrl(this.$route.fullPath, ["channel","vayHub"])
          );
        }
        if (that.$route.query.vayHub) {
          localStorage.setItem("vayHub", that.$route.query.vayHub);
          console.log("this.$route.query.vayHub", that.$route.query.vayHub);
          window.history.replaceState(
              "",
              "",
              that.editUrl(that.$route.fullPath, ["vayHub"])
              // this.editUrl(this.$route.fullPath, ["channel","vayHub"])
          );
        }
      });
    });

    let conf = await config();
    localStorage.setItem("config", JSON.stringify(conf.result));

    let pointByKey = await getPointByKey({channelKey: localStorage.getItem("channel")});
    console.log("pointByKey", pointByKey)
    if (pointByKey.data) {
      localStorage.setItem("pointByKey", pointByKey.data)
      this.pixelEmbedding();
    } else {
      localStorage.removeItem("pointByKey")
    }
  },
  mounted() {
    if (process.env.VUE_APP_GENRE === "nested") {
      this.init();
      this.$store.commit("SET_IS_NESTED", true);
    } else {
      this.$nextTick(() => {
        getIp()
            .then((res) => {
              this.createFingerprint(res.result.ip);
            })
            .catch(() => {
              this.createFingerprint();
            });
      });
    }
  },
};
</script>

<style lang="less">
@main-color: #fe9e44;
@font-family: PingFangSC-Regular, PingFang SC;
#__vconsole {
  transition: none;
}

#__vconsole > * {
  transition: none;
}
</style>
